export const NoLogin = () => {
    const loginUrl = import.meta.env.VITE_LOGIN_URL;
    const redirectUrl = import.meta.env.VITE_LOGIN_REDIRECT + '/create';

    const onLogin = () => {
        window.location.href = loginUrl + redirectUrl;
    };

    return (
        <section className="contwrap main_wrap">
            <div className="contInner" id="card_type">
                <div className="cont_layer bg_white"></div>
                <div className="layer_box notice">
                    <p className="notice_info">
                        <i></i>로
                        <br />
                        온라인 평가를 간편하게 출제하고,
                        <br />
                        자동채점과 리포트 기능으로 평가 기록을 편리하게 관리하세요!
                    </p>
                    <p className="notice_info2">
                        비바샘 계정으로 로그인 후 이용할 수 있으며,
                        <br />
                        초등학교 선생님은 초등 교과서의 자료/문항을,
                        <br />
                        중고등학교 선생님은 중고등 교과서의 자료/문항을 활용할 수 있습니다.
                    </p>
                    <button className="btn btn-default icon blue login" onClick={onLogin}>
                        <i></i>로그인하기
                    </button>
                </div>
            </div>
        </section>
    );
};
